import { PublicClientApplication } from '@azure/msal-browser';
import { MsalInstanceProvider } from '../msal-instance-provider';

class AuthService {
  private readonly msalInstance: PublicClientApplication =
    MsalInstanceProvider.getInstance();

  public getToken(): string | undefined {
    const account = this.msalInstance.getAllAccounts()[0];
    if (!account) {
      return undefined;
    }
    return this.msalInstance.getAllAccounts()[0].idToken;
  }

  public async refreshToken(): Promise<string> {
    try {
      const tokenResponse = await this.msalInstance.acquireTokenSilent({
        scopes: [],
        account: this.msalInstance.getAllAccounts()[0],
      });
      return tokenResponse.idToken;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  }
}

const authService = new AuthService();
export default authService;
